import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-icon-hide',
  templateUrl: './icon-hide.component.html',
  styleUrls: ['./icon-hide.component.scss']
})
export class IconHideComponent implements OnInit {

  @Input() cssClass = '';
  
  constructor() { }

  ngOnInit() {
  }

}
